module.exports = {
	"id": "AN",
	"name": "Netherlands Antilles",
	"month": "2014-08",
	"access_date": "2014-09-01",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.080201,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.051037,
			"22": 0.080201,
			"23": null,
			"24": 0.029164,
			"25": null,
			"26": 0.131238,
			"27": null,
			"28": 0.102074,
			"29": null,
			"30": null,
			"31": 0.51037,
			"32": 0.306222,
			"33": 2.223755,
			"34": 0.204148,
			"35": 1.407163,
			"36": 28.87236,
			"37": null,
			"38": 0.080201,
			"39": null,
			"40": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.029164,
			"11": null,
			"12": 0.051037,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.029164,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.051037,
			"27": 0.029164,
			"28": null,
			"29": 0.029164,
			"30": 4.031923,
			"31": 10.827135,
			"32": 0.051037,
			"33": null,
			"34": null,
			"3.5": null,
			"3.6": null
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.051037,
			"22": null,
			"23": 0.051037,
			"24": 0.051037,
			"25": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.539534
		},
		"safari": {
			"4": 0,
			"5": 0.233312,
			"6": 0.102074,
			"7": 6.05153,
			"8": 0.029164,
			"3.1": null,
			"3.2": null,
			"5.1": 0.765555,
			"6.1": 0.561407
		},
		"android": {
			"3": 0,
			"4": 0.648893454545,
			"2.1": 0.00612163636364,
			"2.2": 0.0428514545455,
			"2.3": 0.832542545455,
			"4.1": 1.62223363636,
			"4.2-4.3": 1.69569327273,
			"4.4": 1.279422,
			"4.4.3": null
		},
		"op_mob": {
			"0": null,
			"10": 0,
			"11": 0,
			"12": 0.0000648307692308,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000356569230769
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 1.4582,
			"9": 2.47894,
			"10": 1.633184,
			"11": 9.471009,
			"5.5": null
		},
		"ios_saf": {
			"8": 0,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0.0939043474576,
			"6.0-6.1": 0.473354567797,
			"7.0-7.1": 8.93049508475
		},
		"bb": {
			"7": 0.40838175,
			"10": null
		},
		"and_ff": {
			"0": 0.051471
		},
		"ie_mob": {
			"10": 0.09419193
		},
		"op_mini": {
			"5.0-7.0": 0.0239596
		},
		"and_chr": {
			"0": 8.88552
		}
	},
	"total": 97.77343668
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/AN.json
 ** module id = 462
 ** module chunks = 0
 **/